module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9xF7i"))).then(() => parcelRequire('9Lwss'));